import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle, Text } from '@reveni-io/reveni-ui'

import ReviewItem from './ReviewItem/ReviewItem'
import * as Styles from './styles'

const ProductsCard = ({ items, onLink, onDiscard }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card>
      <CardTitle>{t('Productos')}</CardTitle>
      <Styles.Subtitle>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {t(
            'Vincula estos productos devueltos adicionales a su pedido original para validarlos, o descártalos si no encuentras un pedido adecuado o no quieres procesar la devolución.'
          )}
        </Text>
      </Styles.Subtitle>
      <Styles.ItemsContainer>
        {items.map((item, idx) => (
          <ReviewItem key={item.id} item={item} index={idx + 1} onLink={onLink} onDiscard={onDiscard} />
        ))}
      </Styles.ItemsContainer>
    </Card>
  )
}

export default ProductsCard
